import { useId } from 'react';
import { WarningCircle } from 'assets/icons';
import UseContext from 'hooks/useContext';

const CHOICES = ['invoices', 'reminders'];

/**
 * The two boxes « Factures » and « Relances » of a billing recipient, member or
 * contact without an account. Controlled: `onChange(field, checked)`.
 */
const BillingContactNotificationChoices = ({
  invoices,
  reminders,
  onChange,
  isDisabled = false,
  error,
}) => {
  const { language } = UseContext();
  const text = (key) =>
    language.getValue(`companyBillingContacts.notifications.${key}`, '');
  const baseId = useId();
  const values = { invoices, reminders };

  return (
    <div className={'flex flex-col gap-2'}>
      <div className={'ft-sm text-gray-500'}>{text('label')}</div>
      <div className={'border border-gray-200 rounded-md divide-y'}>
        {CHOICES.map((field) => {
          const inputId = `${baseId}-${field}`;
          return (
            // The whole row toggles the box; the name stays the title alone,
            // the hint only describes it.
            <label
              key={field}
              htmlFor={inputId}
              className={`flex gap-4 items-start px-4 py-3 ${
                isDisabled ? 'cursor-default' : 'cursor-pointer'
              }`}
            >
              <input
                id={inputId}
                type={'checkbox'}
                checked={values[field] === true}
                disabled={isDisabled}
                onChange={(event) => onChange(field, event.target.checked)}
                aria-labelledby={`${inputId}-title`}
                aria-describedby={`${inputId}-hint`}
                style={{ accentColor: '#F99600' }}
                className={'mt-1 h-4 w-4 shrink-0'}
              />
              <span className={'flex flex-col min-w-0'}>
                <span
                  id={`${inputId}-title`}
                  className={'text-sm font-medium text-gray-900'}
                >
                  {text(field)}
                </span>
                <span
                  id={`${inputId}-hint`}
                  className={'text-sm text-gray-700'}
                >
                  {text(`${field}Hint`)}
                </span>
              </span>
            </label>
          );
        })}
      </div>
      {error ? (
        <div
          role={'alert'}
          className={'text-red-500 flex items-center gap-1 text-xs'}
        >
          <WarningCircle wh={16} color={'#EF4444'} />
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default BillingContactNotificationChoices;
